import React from 'react';
import { Info } from 'lucide-react';

interface InfoBoxProps {
  requirements: {
    required: string;
    optional: string;
    additional?: string;
  };
}

const InfoBox: React.FC<InfoBoxProps> = ({ requirements }) => {
  return (
    <div className="admin-bulk-upload-info-box">
      <Info size={20} className="admin-bulk-upload-info-icon" />
      <div className="admin-bulk-upload-info-content">
        <h3 className="admin-bulk-upload-info-title">CSV Requirements</h3>
        <ul className="admin-bulk-upload-info-list">
          <li><strong>Required fields:</strong> {requirements.required}</li>
          <li><strong>Optional fields:</strong> {requirements.optional}</li>
          <li><strong>{requirements.additional}</strong></li>
        </ul>
      </div>
    </div>
  );
};

export default InfoBox;
